module.exports = __webpack_public_path__ + "img/footer-mail.470fc517.svg";